<template>
    <div class="body">
        <div class="header">
            <el-form class="product-form" :model="SelectOrderManagementDTO" :inline="true">
                <el-form-item label="上传日期">
                    <el-date-picker
                        v-model="date"
                        type="daterange"
                        :picker-options="cellClassName"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd"
                        @change="chooeDate"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="推送拼版状态" size="small" >
                      <el-select clearable size="small" v-model.trim="accountForm.pushStatus" allow-create
                                       filterable
                                      >
                                <el-option
                                    v-for="item in pushStatus"
                                    clearable
                                    :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                />
                            </el-select>
                    </el-form-item>
                    <el-form-item label="支付状态" size="small" >
                      <el-select clearable size="small" v-model.trim="accountForm.paymentStatus" allow-create
                                       filterable
                                      >
                                <el-option
                                    v-for="item in paymentStatus"
                                    clearable
                                    :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                />
                            </el-select>
                    </el-form-item>
                <el-form-item label="客户名称">
                    <el-select clearable v-model="SelectOrderManagementDTO.customerName" allow-create
                               filterable 
                                @blur.native.capture="customerNameSelect">
                        <el-option
                            v-for="item in customerName"
                            clearable
                            :key="item"
                            :label="item"
                            :value="item"
                        />
                    </el-select>
                </el-form-item>

                <el-form-item label="操作员">
                    <el-select clearable v-model="SelectOrderManagementDTO.operator" allow-create
                               filterable
                                @blur.native.capture="operatorSelect">
                        <el-option
                            v-for="item in operator"
                            clearable
                            :key="item"
                            :label="item"
                            :value="item"
                        />
                    </el-select>
                </el-form-item>

                <el-form-item label="订单名称">
                    <el-input

                        v-model="SelectOrderManagementDTO.orderName"
                        placeholder=""
                    ></el-input>
                </el-form-item>
       
                <el-form-item>
                    <el-button class="btn-search" type="success" @click="serchInfo">搜索</el-button>
                </el-form-item>
            </el-form>

            <el-dialog
                text-align="center"
                :close-on-click-modal="false"
                title="下单"
                class="order-dialog"
                width="75%"
                center
                @close="closeDialog"
                :visible.sync="drawer"
            >
                <el-form
                    ref="accountForm"
                    :rules="rules"
                    :model="accountForm"
                    class="demo-accountForm form-style"
                >
                    <div class="accountForm-header">
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="订单名称">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.orderName"
                                        placeholder="请输订单名称"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="客户名称">
                                    <el-select clearable size="small" v-model="accountForm.customerName" allow-create
                                             
                                               class="width100"
                                               filterable
                                                @blur.native.capture="customerNameInSelect">
                                        <el-option
                                            v-for="item in customerName"
                                            clearable
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                        />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="操作员" class="operator">
                                    <el-select clearable size="small" v-model="accountForm.operator" allow-create
                                            
                                               class="width100"
                                               filterable
                                                @blur.native.capture="operatorInSelect"
                                               >
                                        <el-option
                                            v-for="item in operator"
                                            clearable
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                        />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="交货时间" prop="">
                                    <el-date-picker v-model="accountForm.deliveryTime" format="yyyy-MM-dd"
                                                  
                                                    size="small"
                                                    type="datetime"
                                                    value-format="yyyy-MM-dd"
                                                    :style="{width: '100%'}" placeholder="请选择日期选择"></el-date-picker>
                                </el-form-item>
                      
                            </el-col>
                            <el-col :span="8">
                                <el-form-item style="margin-top: 5px" label="交货方式" prop="deliveryMethod">
                                    <el-select clearable size="small" v-model="accountForm.deliveryMethod" allow-create
                                              
                                               filterable class="width100"
                                                @blur.native.capture="deliveryMethodInSelect"
                                               >
                                        <el-option
                                            v-for="item in deliveryMethod"
                                            clearable
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                        />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item style="margin-top: 5px" label="收款账户" prop="collectionAccount">
                                    <el-select clearable size="small" v-model="accountForm.collectionAccount" allow-create
                                              
                                               class="width100"
                                               filterable
                                                @blur.native.capture="collectionAccountInSelect">
                                        <el-option
                                            v-for="item in collectionAccount"
                                            clearable
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                        />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="订单金额"  :disabled="detailDisable">
                                    <span class="table-label" ></span>
                                            <span class="table-value" style="color: #1bd16d;">{{accountForm.orderAmount?accountForm.orderAmount:'---'}}</span>
                                </el-form-item>
                      
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="已付款">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.amount"
                                        :disabled="detailDisable"
                                        placeholder="请输入"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="优惠金额">
                                    <el-input
                                        class="input-name"
                                        size="small"
                                        v-model="accountForm.preferentialAmount"
                                        :disabled="detailDisable"
                                        placeholder="请输入"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="备注" prop="operator">
                                    <el-input
                                        class="input-remark"
                                        type="textarea"
                                       
                                        v-model="accountForm.remarks"
                                        placeholder="请输入备注"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item label="上传缩略图" class="errorPageImg dialog-upload">
                                    <el-upload
                                        class="avatar-uploader"
                                        action="api/serviceCenter/orderInfo/orderThumbnailUpload"
                                        name="files"
                                        :show-file-list="false"
                                        :on-success="thumbnailPathSuccess"
                                        :before-upload="beforeAvatarUpload"
                                    >
                                        <img v-if="accountForm.thumbnailPath" :src="accountForm.thumbnailPath"
                                             style="max-height: 100px;max-width: 100px; cursor:pointer" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <el-button  type="warning" class="btn-add" size="small" @click="showGoodsList" >添加商品</el-button>
                    <el-button
                        class="form-submit"
                        size="small"
                        type="success"
                        @click="submitForm('accountForm')"
                        v-if="!detailDisable"
                    >
                        立即创建
                    </el-button>
                    <el-button
                        class="form-submit"
                        size="small"
                        type="success"
                        @click="updateOrder('accountForm')"
                        v-if="detailDisable"
                    >
                        确认修改
                    </el-button>
                    <el-table
                        v-if="goodsTableData && goodsTableData.length"
                        :data="goodsTableData"
                        stripe
                        border
                        style="width: 100%"
                        class="goodsTableData"
                    >
                    <el-table-column   prop="row"
                            align="center"
                            label="删除">
                    <template slot-scope="scope">
              <i class="el-icon-remove-outline"   @click="deleteThis(scope.row,scope.$index)">
                </i>
            </template>
                    </el-table-column>
          
                        <el-table-column
                            prop="category"
                            align="center"
                            label="产品名称"
                        ></el-table-column>
                        <el-table-column
                            prop="num"
                            align="center"
                            label="数量"
                        ></el-table-column>
                        <el-table-column
                            prop="listPrice"
                            align="center"
                            label="单价"
                        ></el-table-column>
                        <el-table-column
                            prop="subclass"
                            align="center"
                            label="产品类别"
                            width="130"
                        ></el-table-column>
                        <el-table-column
                            prop="processRequirements"
                            align="center"
                            label="工艺要求"
                            width="130"
                        ></el-table-column>
                        <el-table-column
                            prop="remarks"
                            align="center"
                            label="备注"
                            width="130"
                        ></el-table-column>
                        <el-table-column
                            prop="thumbnailPath"
                            label="缩略图"
                            align="center"
                            width="200">
                            <template slot-scope="scope">
                                <el-popover placement="top-start" trigger="click">
                                    <!--trigger属性值：hover、click、focus 和 manual-->
                                    <a :href="scope.row.thumbnailPath" target="_blank" title="查看最大化图片">
                                        <img :src="scope.row.thumbnailPath" style="max-height: 800px;max-width: 800px">
                                    </a>
                                    <img slot="reference" :src="scope.row.thumbnailPath"
                                         style="max-height: 50px;max-width: 50px cursor:pointer">
                                </el-popover>
                            </template>
                        </el-table-column>

<!--                        <el-table-column-->
<!--                            prop="number"-->
<!--                            align="center"-->
<!--                            label="产品编号"-->
<!--                            width="180"-->
<!--                        ></el-table-column>-->
                        <el-table-column
                            prop="unit"
                            align="center"
                            label="单位"
                        ></el-table-column>
                        <el-table-column
                            prop="specifications"
                            align="center"
                            label="规格"
                        ></el-table-column>


<!--                        <el-table-column-->
<!--                            prop="boringList"-->
<!--                            align="center"-->
<!--                            label="文件清单"-->
<!--                            show-overflow-tooltip-->
<!--                        ></el-table-column>-->
<!--                        <el-table-column-->
<!--                            prop="nature"-->
<!--                            align="center"-->
<!--                            label="产品性质"-->
<!--                            width="100"-->
<!--                        >-->
<!--                            <template slot-scope="scope">-->
<!--                                <el-tag type=" info" v-if="scope.row.nature==='0'">常规产品</el-tag>-->
<!--                                <el-tag type="success" v-if="scope.row.nature==='1'">标准件</el-tag>-->
<!--                            </template>-->
<!--                        </el-table-column>-->
                    </el-table>


<!--                    <el-form-item>-->
<!--                        <el-button-->
<!--                            class="form-submit"-->
<!--                            size="small"-->
<!--                            type="primary"-->
<!--                            v-if="!detailDisable"-->
<!--                            @click="submitForm('accountForm')"-->
<!--                        >-->
<!--                            立即创建-->
<!--                        </el-button>-->
<!--                    </el-form-item>-->
                </el-form>
            </el-dialog>
            <div style="display: flex">
            </div>
        </div>
        <el-dialog title="收款" :visible.sync="dialogVisible" width="28%" :close-on-click-modal="false">
            <el-form
                ref="accountForm"
                :model="accountForm"
                label-width="100px"
                class="demo-accountForm"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="客户名称" prop="collectionAccount">
                            <h4>{{ accountForm.customerName }}</h4>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="收款人" prop="accountType">
                            <el-select clearable size="small" v-model="accountForm.operator" allow-create filterable
                             @blur.native.capture="operatorInSelect">
                                <el-option
                                    v-for="item in operator"
                                    clearable
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="订单总金额">
                            <h4>{{ accountForm.orderAmount }}</h4>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="欠款金额" prop="remake">
                            <h4>{{ accountForm.unpaid }}</h4>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="优惠金额">
                            <el-input
                                class="input-remark"
                                size="small"
                                v-model="accountForm.preferentialAmount"
                                placeholder="请输入账户类型"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="收款账户" prop="accountType">
                            <el-select clearable size="small" v-model="accountForm.collectionAccount" allow-create
                                       filterable
                                        @blur.native.capture="collectionAccountInSelect">
                                <el-option
                                    v-for="item in collectionAccount"
                                    clearable
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="收款日期" prop="">
                            <el-date-picker v-model="accountForm.transactionTime" format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            :style="{width: '100%'}" placeholder="请选择日期选择"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="本次实收">
                            <el-input
                                class="input-remark"
                                size="small"
                                v-model="accountForm.amount"
                                placeholder=""
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="备注信息" prop="panelMaterial">
                    <el-input v-model="accountForm.remarks" type="textarea"></el-input>
                </el-form-item>
                <el-form-item label="上传缩略图" class="errorPageImg">
                    <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/orderInfo/orderThumbnailUpload"
                        name="files"
                        :show-file-list="false"
                        :on-success="thumbnailPathSuccess"
                        :before-upload="beforeAvatarUpload"
                    >
                        <img v-if="accountForm.thumbnailPath" :src="accountForm.thumbnailPath"
                             style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="editAccount()">
            确认收款
          </el-button>
        </span>
        </el-dialog>

        <el-divider></el-divider>

        <div class="table-content">
            <div class="flex_between_middle">
                <div>
                    <span class="check-all" @click="handleSelectionChange">全选</span>
                    <el-button size="small" class="btn-style btn-buy" type="warning" @click="tohandleEdit">下单</el-button>
                    <el-button size="small" class="btn-style btn-print" type="primary" @click="toPrint">打印</el-button>
                    <el-button size="small" class="btn-style btn-delete" type="success" @click="automaticAssembly">推送拼版</el-button>
                    <el-button size="small" class="btn-style btn-delete" type="danger" @click="handleDelete">删除</el-button>
                    <!-- <el-button size="small" class="btn-style btn-view" type="success" @click="viewProducts">查看产品</el-button> -->
            </div>
            <div class="x_flex gap50 mb-10" style="margin-left: 50px">
                 <p>
                            <span class="table-label">  订单金额总计:&#8195;</span>
                            <span class="table-value" style="color: #18b6f5;">{{amounts.orderAmounts}}</span>
                        </p>
                        <p>
                            <span class="table-label">  &#8195;待付款总计:</span>
                            <span class="table-value" style="color: #d12525;">{{amounts.unpaids}}</span>
                        </p>
                </div>
                <div class="pagination">
                    <el-pagination
                        :current-page="currentPage"
                        :page-sizes="[10, 30, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                    ></el-pagination>
                </div>
              
         
            </div>
            <el-divider></el-divider>
            <div>
       
       <el-button @click="downLoadFloors" class="btn-style btn-print" type="primary" size="small">下载底板文件</el-button>
       <el-button @click="downLoadPanels" class="btn-style btn-print" type="primary" size="small">下载面板文件</el-button>
       <el-button @click="downLoadKeeps" class="btn-style btn-print" type="primary" size="small">下载存档文件</el-button>
       <el-button @click="downLoadManuscripts" class="btn-style btn-print" type="primary" size="small">下载字稿文件</el-button>
            </div>

            <div class="table-list">
                <div v-for="item in conTract" :key="item.id" :class="['table-item',{'table-no-pay':item.paymentStatus == '0'}]">
                    <div class="x_flex gap50 mb-10" style="margin-left: 50px">
                        <p>
                            <span class="table-label">开单时间：</span>
                            <span class="table-value">{{item.orderTime}}</span>
                        </p>
                        <p>
                            <span class="table-label">发货时间：</span>
                            <span class="table-value">{{item.deliveryTime}}</span>
                        </p>
                        <p>
                                            <span class="table-label">推送拼版状态：</span>
                                            <span v-if="item.pushStatus == '1'" class="pay">已推送</span>
                                            <span v-else class="no-pay">未推送</span>
                                        </p>
                        <p>
                                            <span class="table-label">计件数量:</span>
                                            <span class="table-value">{{item.area?item.area:'--'}}</span>
                        </p>
                        <p class="text-overflow" style="width:300px;" :title="item.remarks">
                            <span class="table-label">备注:</span>
                            <span class="table-value">{{item.remarks?item.remarks:'--'}}</span>
                        </p>
                    </div>
                    <div class="flex_between_middle">
                        <div class="flex_center_middle" style="flex:1;">
                            <el-checkbox style="width: 50px;" v-model="item.checked"></el-checkbox>
                            <div class="flex_center_middle" style="flex:1;">

                                <el-image
                                    class="table-image"
                                    :src="item.thumbnailPath"
                                    :preview-src-list="[item.thumbnailPath]">
                                    <div slot="error" class="image-slot">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                </el-image>
                          
                                <div style="flex:1;">
                                    <div class="x_flex gap20 table-info">
                                        <p>
                                            <span class="table-label">客户名称：</span>
                                            <span class="table-value">{{item.customerName?item.customerName:'--'}}</span>
                                        </p>
                                        <p>
                                            <span class="table-label">订单名称：</span>
                                            <span class="table-value">{{item.orderName?item.orderName:'--'}}</span>
                                        </p>
                                        <p>
                                            <span class="table-label">操作员：</span>
                                            <span class="table-value">{{item.operator?item.operator:'--'}}</span>
                                        </p>
                                        <p>
                                            <span class="table-label">发货方式：</span>
                                            <span class="table-value">{{item.deliveryMethod?item.deliveryMethod:'--'}}</span>
                                        </p>
                                        <p>
                                            <span class="table-label">收款账户：</span>
                                            <span class="table-value">{{item.collectionAccount?item.collectionAccount:'--'}}</span>
                                        </p>
                                    </div>
                                    <div class="x_flex gap20 table-info">
                                        <p>
                                            <span class="table-label">订单金额：</span>
                                            <span class="table-value">{{item.orderAmount?item.orderAmount:'--'}}</span>
                                        </p>
                                        <p>
                                            <span class="table-label">已付款：</span>
                                            <span class="table-value">{{item.paid?item.paid:'--'}}</span>
                                        </p>
                                        <p>
                                            <span class="table-label">优惠金额：</span>
                                            <span class="table-value">{{item.preferentialAmount?item.preferentialAmount:'--'}}</span>
                                        </p>
                                        <p>
                                            <span class="table-label">待付款：</span>
                                            <span class="table-value">{{item.unpaid?item.unpaid:'--'}}</span>
                                        </p>
                                        <p>
                                            <span class="table-label">支付状态：</span>
                                            <span v-if="item.paymentStatus == '1'" class="pay">已结清</span>
                                            <span v-else class="no-pay">未结清</span>
                                        </p>
                                  
                                    </div>
                    
                                </div>
                                <span class="table-label">计件二维码：</span>
                                        <el-image
                                    class="table-image"
                                    style="width:100px;height:100px"
                                    :src="item.dimensionalBarcode"
                                    :preview-src-list="[item.dimensionalBarcode]">
                                    <div slot="error" class="image-slot">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                </el-image> </div>
                        </div>
                        <div class="btn-group">
                            <div><el-button class="btn-collection" size="mini" plain type="danger" @click="handleEdit(item)">收款</el-button></div>
                            <div><el-button class="btn-view-detail" size="mini" plain type="success" @click="orderINfo(item)">编辑</el-button></div>
                            <div><el-button class="btn-reckon" size="mini" plain type="warning" @click="tpReckon(item)">计件管理</el-button></div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <goods-list ref="goodsList" @chooseGoods="handleChooseGoods"></goods-list>
        <view-products ref="viewProducts"></view-products>
    </div>
</template>

<script>
import {
    addTransaction,
    selectOrderManagement,
    bathDeleteOrder,
    automaticAssembly,
    addOrderManagement,
    selectAllCustomer,
    selectAllUser,
    selectAllCollection,
    selectAllDistribution,
    selectOrderInfo,
    getCompany,
    selectOrderCustomer,
    updateOrderManagement,
    selectOrderManagementAmount
} from '@/api/order/orderManagement.js'
import goodsList from './components/goodsList'
import viewProducts from './components/viewProducts'

export default {
    components: {
        goodsList,
        viewProducts
    },
    data() {
        return {
            testDrawer: true,
            pageSize: 10,
            total: 0,
            currentPage: 1,
           //  multipleSelection: [],
            ids: '',
            OrderCustomerDTO: {
                access: '',
                customerName: ''
            },
            SelectOrderInformationDTO: {
                orderId: '',
                orderName: '',
                operator: '',
                customerName: '',
                startTime: '',
                endTime: '',
                access: '',
                productType: ''
            },
            customerName: [],
            cellClassName: {
                shortcuts: [
                    {
                        text: '最近一天',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三天',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]

            },
            date: '',
            conTract: [],
            operator: [],
            SelectOrderManagementDTO: {
                startTime: '',
                endTime: '',
                operator: '',
                customerName: '',
                orderName: '',
                preferentialAmount: '',
                orderNumber: '',
                paymentStatus:'',
                access: ''
            },
            access: '',
            collectionAccount: [],
            deliveryMethod: [],
            drawer: false,
            dialogVisible: false,
            orderDate: [],
            accountForm: {
                id: '',
                access: '',
                collectionAccount: '',
                accountType: '',
                operator: '',
                area:'',
                customerName:'',
                deliveryMethod:'',
                unpaid: '',
                orderTime: '',
                transactionTime: '',
                preferentialAmount: '',
                thumbnailPath: '',
                orderAmount:'',
                paid:'',
                preferentialAmount:'',
                amount: '',
                orderId: '',
                dimensionalBarcode:'',
                paymentStatus:'',
                remake: ''
            },
            searchForm: {
                startTime: '',
                secondStartTime: '',
                number: '',
                values: ''
            },
            DeleteDTO: {
                id: '',
                status: ''
            },
            rules: {
                // collectionAccount:[
                //         { required: true, message: '请输入收款账户', trigger: 'blur' }]
            },
            amounts:{
                orderAmounts:'',
                unpaids:'',
                paid:'',
                preferentialAmount:''
            },
            pushStatus:[{
            value: '0',
            label: '未推送'
            }, {
                value: '1',
                label: '已推送'
            },
     
            ],
            paymentStatus:[{
                    value: '0',
                    label: '未结清'
                    }, {
                        value: '1',
                        label: '已结清'
                    },
                ],
            orderInfo: {
                userName: '',  //公司名称
                customerName: '', //客户名称
                contacts: '',  //联系人
                telephone: '', //联系电话
                orderTime: '', //下单时间
                address: '', //联系地址
                remarks: '', //备注
                orderAmount: '', //总价
                paid: '', //收款
                unpaid: '', //欠款
                operator: '', //开单人
                deliveryMethod: '', //交货方式
                preferentialAmount: '',
                deliveryTime: '' , //交货时间
                thumbnailPath:'',
                dimensionalBarcode:'',//二维码地址
            },


            goodsTableData: [],            //商品展示
            detailDisable:false,
        }

    },
    computed:{
        multipleSelection(){
            return this.conTract.filter(item=>item.checked)
        }
    },
created() {
  
},
watch:{
 'goodsTableData' : {
   handler : function(newVal,oldVal){
    var  summer=0;
            this.goodsTableData.forEach(function (value) {
                summer+=value.num*value.listPrice
            }) 
            this.accountForm.orderAmount=summer
   }
 }
},

    mounted() {
        this.access = localStorage.getItem("access")
        this.SelectOrderManagementDTO.access = localStorage.getItem("access")
        this.accountForm.access = localStorage.getItem("access")
        this.getDeliveryMethod();
        this.getCustomer();
        this.getOperator();
        this.getCollectionAccount();
        this.defaultDate();
        this.getTableData();
      // 进入页面调用一次获取数据的方法
    },
    methods: {
        styleBack({row, column, rowIndex, columnIndex}) {
            // if (columnIndex == 0) {
            //   return { color: '#0c87ef' }
            // }
        },
        deleteThis(row,index) {
            this.goodsTableData.splice(index,1)
    },

        async toPrint() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    type: "error",
                    message: "sorry,你还没有勾选呢!"
                });
                return;
            }
            if (this.multipleSelection.length > 1) {
                this.$message({
                    type: "error",
                    message: "一次只能打印一个订单!"
                });
                return;
            }
            //获取订单信息
            this.SelectOrderInformationDTO.access = localStorage.getItem("access")
            this.SelectOrderInformationDTO.orderId = this.multipleSelection[0].id
            await selectOrderInfo(1, 1000, this.SelectOrderInformationDTO).then((res) => {
                this.orderDate = res.data.data.records
            })
            this.orderInfo.customerName = this.multipleSelection[0].customerName
            this.orderInfo.orderTime = this.multipleSelection[0].orderTime
            this.orderInfo.remarks = this.multipleSelection[0].remarks
            this.orderInfo.orderAmount = this.multipleSelection[0].orderAmount
            this.orderInfo.paid = this.multipleSelection[0].paid
            this.orderInfo.preferentialAmount = this.multipleSelection[0].preferentialAmount
            this.orderInfo.unpaid = this.multipleSelection[0].unpaid
            this.orderInfo.operator = this.multipleSelection[0].operator
            this.orderInfo.deliveryMethod = this.multipleSelection[0].deliveryMethod
            this.orderInfo.deliveryTime = this.multipleSelection[0].deliveryTime
            this.orderInfo.deliveryTime = this.multipleSelection[0].deliveryTime
            this.orderInfo.thumbnailPath = this.multipleSelection[0].thumbnailPath
            this.orderInfo.dimensionalBarcode = this.multipleSelection[0].dimensionalBarcode
            
            await getCompany(localStorage.getItem("access")).then((res) => {
                if (res.data.data) {
                    this.orderInfo.userName = res.data.data.userName
                }
            })
            //获取客户信息
            this.OrderCustomerDTO.access = localStorage.getItem("access")
            this.OrderCustomerDTO.customerName = this.multipleSelection[0].customerName
            await selectOrderCustomer(this.OrderCustomerDTO).then((res) => {
                if (res.data.data) {
                    this.orderInfo.contacts = res.data.data.contacts
                    this.orderInfo.telephone = res.data.data.telephone
                    this.orderInfo.address = res.data.data.address
                }
            })

            await this.$router.push({
                path: '/print',
                query: {
                    orderInfo: this.orderInfo,
                    orderDate: this.orderDate,
                    tableRow:this.multipleSelection[0],
                }
            })
        },
        tpReckon(row){
            console.log(row)
            this.$router.push({
                path: '/reckon',
                query: {
                    orderId: row.id,
                    category:row.orderInformations[0].category
                }
            })
        },
        getCustomer() {
            selectAllCustomer(this.access).then((res) => {
                this.customerName = res.data.data
                //  this.total = Number(res.data.data.total)
            })
        },

        getOperator() {
            selectAllUser(this.access).then((res) => {
                this.operator = res.data.data
            })
        },
        getCollectionAccount() {
            selectAllCollection(this.access).then((res) => {
                this.collectionAccount = res.data.data
            })
        },
        getDeliveryMethod() {
            selectAllDistribution(this.access).then((res) => {
                this.deliveryMethod = res.data.data
            })
        },
        

        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`)
            this.pageSize = val
            this.getTableData()
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`)
            this.currentPage = val
            this.getTableData()
        },

        tohandleEdit() {
            this.accountForm = Object.assign({}, this.$options.data().accountForm);
            this.accountForm.access = localStorage.getItem("access")
            this.drawer = true
            this.detailDisable = false
        },
        handleEdit(row) {
            this.dialogVisible = true
            this.accountForm = row
            this.accountForm.orderId = row.id
            this.accountForm.preferentialAmount = "0"
            this.accountForm.remarks = ''
        },
        orderINfo(row) {
            this.accountForm = {...row}
            this.goodsTableData = row.orderInformations || []
            this.detailDisable = true
            this.drawer = true
            // this.$router.push({
            //     path: '/orderInfo',
            //     query: {
            //         orderId: row.id,
            //     }
            // })
        },
        getTableData() {
            selectOrderManagement(this.currentPage, this.pageSize, this.SelectOrderManagementDTO).then((res) => {
                this.conTract = res.data.data.records
                this.total = Number(res.data.data.total)
            })
            selectOrderManagementAmount(this.SelectOrderManagementDTO).then((res) => {
                this.amounts=res.data.data; 
                console.log(this.amounts)
            })
        },
   
        thumbnailPathSuccess(res, file) {
            this.accountForm.thumbnailPath = res.data.ori_file[0];
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error('上传缩略图图片只能是 JPG/PNG/JPEG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传缩略图大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        submitForm(accountForm) {
            if (this.accountForm.orderAmount - this.accountForm.preferentialAmount - this.accountForm.amount < 0) {
                this.$message({
                    type: "error",
                    message: "sorry,付款总金额大于总金额"
                });
                return;
            }
            this.$refs[accountForm].validate((valid) => {
                if (valid) {
                    this.accountForm.productToOrderDTOS = this.goodsTableData
                    addOrderManagement(this.accountForm).then((res) => {
                        if (res.data.msg === '操作成功') {
                            this.drawer = false
                            this.$message({
                                type: 'success',
                                message: '添加成功!',
                            })
                            this.getTableData()
                        } else{
                            this.$message({
                                type: 'info',
                                message: res.data.data
                            })
                        }
                    })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        updateOrder(accountForm){
            this.$refs[accountForm].validate((valid) => {
                if (valid) {
                    this.accountForm.productToOrderDTOS = this.goodsTableData
                    updateOrderManagement(this.accountForm).then((res) => {
                        if (res.data.msg === '操作成功') {
                            this.drawer = false
                            this.$message({
                                type: 'success',
                                message: '添加成功!',
                            })
                            this.getTableData()
                        } else{
                            this.$message({
                                type: 'info',
                                message: res.data.data
                            })
                        }
                    })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
      
        closeDialog(){
            this.accountForm = {
                id: '',
                access: '',
                collectionAccount: '',
                accountType: '',
                operator: '',
                unpaid: '',
                orderTime: '',
                transactionTime: '',
                preferentialAmount: '',
                thumbnailPath: '',
                amount: '',
                orderId: '',
                remake: ''
            }
            this.goodsTableData = []
        },
        //收款
        editAccount() {
            if (this.accountForm.unpaid - this.accountForm.preferentialAmount - this.accountForm.amount < 0) {
                this.$message({
                    type: "error",
                    message: "sorry,付款总金额大于欠款金额"
                });
                return;
            }
            addTransaction(this.accountForm).then((res) => {
                if (res.data.msg === '操作成功') {
                    this.$message({
                        type: 'success',
                        message: '收款成功!',
                    }),
                        this.getTableData()
                    this.dialogVisible = false
                } else if (res.data.msg !== '操作成功') {
                    this.$message({
                        type: 'info',
                        message: res.data.data
                    })
                }
            })
        },
        handleDelete(row) {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    type: "error",
                    message: "sorry,你还没有勾选呢!"
                });
                return;
            }
            this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    bathDeleteOrder(this.multipleSelection).then((res) => {
                        if (res.data.msg === '操作成功') {
                            this.$message({
                                type: 'success',
                                message: '删除成功!',
                            }),
                                this.getTableData()

                        } else if (res.data.msg !== '操作成功') {
                            this.$message({
                                type: 'info',
                                message: res.data.data
                            })
                        }
                    })
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        
        automaticAssembly(row) {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    type: "error",
                    message: "sorry,你还没有勾选呢!"
                });
                return;
            }
                   automaticAssembly(this.multipleSelection).then((res) => {
                        if (res.data.msg === '操作成功') {
                            this.$message({
                                type: 'success',
                                message: '推送成功!',
                            }),
                                this.getTableData()
                        } else if (res.data.msg !== '操作成功') {
                            this.$message({
                                type: 'info',
                                message: res.data.data
                            })
                        }
                    })
        },
        //查看勾选的订单下的产品
        viewProducts(){
            if(!this.multipleSelection.length)
                return this.$message.warning('请选择订单')
            const goodsTable = this.multipleSelection.map(item=>{
                if(item.orderInformations && item.orderInformations.length) return item.orderInformations
            }).flat(1)
            this.$refs.viewProducts.visible(goodsTable)
        },


        deleteInfo() {
            bathDeleteFile(this.multipleSelection).then((res) => {
                if (res.data.code === 10000) {
                    this.getTableData()
                }
            })
        },

        handleSelectionChange() {
         let flag = true
         if(this.conTract.every(item=>item.checked)) flag = false
         this.conTract.forEach(item => {
            this.$set(item,'checked',flag)
         });
        },
        // 导出
        exportExcelData() {
            exportData(this.searchForm, this.currentPage, this.total)
                .then((res) => {
                    if (res.status == 200) {
                        exportExcel(res.data, res)
                        this.$message({
                            type: 'success',
                            message: '导出成功!'
                        })
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        chooeDate(e) {
            if (e) {
                this.SelectOrderManagementDTO.startTime = e[0]
                this.SelectOrderManagementDTO.endTime = e[1]
            } else if (!e) {
                this.SelectOrderManagementDTO.startTime = ''
                this.SelectOrderManagementDTO.endTime = ''
            }
        },
        // 搜索
        serchInfo() {
            this.getTableData()
        },


        showGoodsList() {
            this.$refs.goodsList.visible(this.goodsTableData)
        },

        //接收选择的商品
        handleChooseGoods(val) {
            this.goodsTableData = val || []
    
            console.log(this.goodsTableData)
        },
        // 初始化默认时间
    defaultDate() {
      var date = new Date()
      var year = date.getFullYear().toString()
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
      // var da = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
      var da = new Date(date.getFullYear(), month, 0).getDate()
      da < 10 ? '0' + da.toString() : da.toString()
      var start = year + '-' + month + '-01'
   
      this.SelectOrderManagementDTO.startTime= new Date(start)
      const end = new Date()
     
      this.SelectOrderManagementDTO.endTime= end
      this.date=[this.SelectOrderManagementDTO.startTime,this.SelectOrderManagementDTO.endTime]
     //将值设置给插件绑定的数据
     
    
    },
    handleTimeOld (time, split) {  //是我用来获取当月的第一天的
        let date = new Date(time)
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        split = '-'
        return [year, month, 1].map(num => this.formatNumber(num)).join(split)
      },


        customerNameSelect(e) {
                if(e.target.value) {
                    this.SelectOrderManagementDTO.customerName = e.target.value
             }
        },
        operatorSelect(e) {
                if(e.target.value) { 
                    this.SelectOrderManagementDTO.operator = e.target.value
            }
        },
        
        customerNameInSelect(e) {
                if(e.target.value) { 
                    this.accountForm.customerName = e.target.value
            }
        },
        operatorInSelect(e) {
                if(e.target.value) { 
                    this.accountForm.operator = e.target.value
            }
        },
        deliveryMethodInSelect(e) {
                if(e.target.value) { 
                    this.accountForm.deliveryMethod = e.target.value
            }
        },
        collectionAccountInSelect(e) {
                if(e.target.value) { 
                    this.accountForm.collectionAccount = e.target.value
            }
        },
 downLoadFloors() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    type: "error",
                    message: "sorry,你还没有勾选任何文件呢!"
                });
                return;
            }
            let orderName = this.multipleSelection[0].orderName;
            this.$message({
                type: 'success',
                message: '正在死命下载中,请稍等!!!!',
            }),
                fetch("api/serviceCenter/orderInfo/downLoadFloors", {
                    body: JSON.stringify(this.multipleSelection),
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }).then(res => {
                    let flag = false
         this.conTract.forEach(item => {
            this.$set(item,'checked',flag)
         });
                   this.getTableData()
                    res.blob().then(blob => {
                        // 转化为blobURL后再通过a标签下载
                        console.log(window.URL.createObjectURL(blob))
                        const blobUrl = window.URL.createObjectURL(blob);
                        const a = window.document.createElement('a');
                        a.href = blobUrl;
                      let time= this.getCurrentTime();
                        a.download = "底板文件" + time + '.zip';
                        a.click();
                        window.URL.revokeObjectURL(blobUrl);

                    });
                });
        },
        getCurrentTime() {
        //获取当前时间并打印
        var _this = this;
    let yy = new Date().getFullYear();
    let mm = new Date().getMonth()+1;
    let dd = new Date().getDate();
    let hh = new Date().getHours();
    let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
    let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
    _this.gettime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
    return _this.gettime;
    },
        downLoadPanels() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    type: "error",
                    message: "sorry,你还没有勾选任何文件呢!"
                });
                return;
            }
            let orderName = this.multipleSelection[0].orderName;
            this.$message({
                type: 'success',
                message: '正在死命下载中,请稍等!!!!',
            }),
                fetch("api/serviceCenter/orderInfo/downLoadPanels", {
                    body: JSON.stringify(this.multipleSelection),
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }).then(res => {
                   this.getTableData()
                    res.blob().then(blob => {
                        // 转化为blobURL后再通过a标签下载
                        console.log(window.URL.createObjectURL(blob))
                        const blobUrl = window.URL.createObjectURL(blob);
                        const a = window.document.createElement('a');
                        let time= this.getCurrentTime();
                        a.href = blobUrl;
                        a.download = '面板文件'+time + '.zip';
                        a.click();
                        window.URL.revokeObjectURL(blobUrl);

                    });
                });
        },

        downLoadKeeps() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    type: "error",
                    message: "sorry,你还没有勾选任何文件呢!"
                });
                return;
            }
            let orderName = this.multipleSelection[0].orderName;
            this.$message({
                type: 'success',
                message: '正在死命下载中,请稍等!!!!',
            }),
                fetch("api/serviceCenter/orderInfo/downLoadKeeps", {
                    body: JSON.stringify(this.multipleSelection),
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }).then(res => {
                   this.getTableData()
                    res.blob().then(blob => {
                        // 转化为blobURL后再通过a标签下载
                        console.log(window.URL.createObjectURL(blob))
                        const blobUrl = window.URL.createObjectURL(blob);
                        const a = window.document.createElement('a');
                        let time= this.getCurrentTime();
                        a.href = blobUrl;
                        a.download = '存档文件'+time + '.zip';
                        a.click();
                        window.URL.revokeObjectURL(blobUrl);

                    });
                });
        },
        downLoadManuscripts() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    type: "error",
                    message: "sorry,你还没有勾选任何文件呢!"
                });
                return;
            }
            let orderName = this.multipleSelection[0].orderName;
            this.$message({
                type: 'success',
                message: '正在死命下载中,请稍等!!!!',
            }),
                fetch("api/serviceCenter/orderInfo/downLoadManuscripts", {
                    body: JSON.stringify(this.multipleSelection),
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }).then(res => {
                   this.getTableData()
                    res.blob().then(blob => {
                        // 转化为blobURL后再通过a标签下载
                        console.log(window.URL.createObjectURL(blob))
                        const blobUrl = window.URL.createObjectURL(blob);
                        const a = window.document.createElement('a');
                        let time= this.getCurrentTime();
                        a.href = blobUrl;
                        a.download = '存档文件'+time + '.zip';
                        a.click();
                        window.URL.revokeObjectURL(blobUrl);

                    });
                });
        },
    }
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
}

.body {
    overflow: auto;
}

.pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
}

.el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
.goodsTableData{
    margin: 20px 0 ;
}
.btn-style{
    min-width: 72px;
    border-radius: 8px;
}
.btn-search{
    background: var(--theme-color);
}
.btn-buy{
    background: #FF8429;
}
.btn-print{
    background: #4093FF;
}
.btn-delete{
    background: #FF4D4D;
}
.btn-view{
    background: var(--theme-color);
}
.product-form .el-form-item{
    margin-bottom: 0;
}
.table-content{
    margin: 20px;
}
.check-all{
    color: #333;
    font-size: 16px;
    margin-right: 20px;
    cursor: pointer;
}
.el-pagination{
    margin: 0;
}

.el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
    border-radius: 8px;
}

.table-label{
    color: var(--secondColor);
}
.table-value{
    color: var(--color);
}
.table-info{
    width: 80%;
    justify-content: space-between;
}
.table-info > p{
    display: inline-block;
    width: 150px;
    padding-right: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 0;
}
.table-item{
    background: #F7F7F7;
    margin: 8px 0;
    border-radius: 12px;
    padding: 12px;
}
.table-image{
    width: 100px;
    height: 50px;
    margin-right: 20px;
}
::v-deep.table-image .image-slot{
    height: 50px;
    display: flex;
    align-items: center;
}
::v-deep.table-image .image-slot i{
    font-size: 50px;
}
.pay{
    color:var(--theme-color);
}
.no-pay{
    color:#FF4D4D;
}
.btn-group{
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.btn-group .el-button{
    border-radius: 20px;
    width: 76px;
}
.btn-collection{
    background: #F9DDDD;
}
.btn-view-detail{
    background: #D3F2E4;
    color: var(--theme-color);
}
.btn-reckon{
    background: rgb(245, 233, 212);
  
}

::v-deep.order-dialog .el-dialog{
    border-radius: 24px;
}
.operator label{
    letter-spacing: 5px;
}
::v-deep.dialog-upload{
    display: flex;
}
::v-deep.dialog-upload .el-form-item__label{
    flex-shrink: 0;
}
::v-deep.dialog-upload .el-form-item__content{
    justify-content: right;
}
::v-deep.dialog-upload .avatar-uploader{
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px solid #D8E0DD;
}
::v-deep.dialog-upload .el-upload--text{
    width: 100%;
    height: 100%;
}
::v-deep.dialog-upload img{
    max-width: 100px;
}
.accountForm-header{
    background: #F7F7F7;
    border-radius: 16px;
    margin-bottom: 20px;
    padding: 20px;
}
.btn-add{
    background: #FF8429;
    border-radius: 8px;
}
.form-submit{
    background: var(--theme-color);
    border-radius: 8px;
}
::v-deep.el-table thead th{
    background: #EAF4F0;
    color: var(--secondColor);
}
.table-no-pay{
    background: #ffeded;
}

::v-deep.el-icon-remove-outline{
    font-size: 32px;
    color: #a3d8f9cc;
}
</style>
